import CountriesModel from '../Apis/Countries'
import Controller from './Controller'

export default class CountriesController extends Controller {
  constructor() {
    super(new CountriesModel())
  }
}
